import React, { useState, useEffect } from 'react';
import { Fetch } from '../../utils/Utils.js';
import { useTranslation } from 'react-i18next';

export const BullDropdown = ({ value, onChange, bulls: propsBulls }) => {
  const { t } = useTranslation();
  const [bulls, setBulls] = useState(propsBulls || []);

  useEffect(() => {
    // If bulls are passed as props, use those
    if (propsBulls) {
      setBulls(propsBulls);
      return;
    }
    // Otherwise fetch them
    Fetch('api/data/reproduction.bulls', 'get', null,
      (data) => { setBulls(data || []); }
    );
  }, [propsBulls]);

  return (
    <select name="bull" value={value || ""} onChange={onChange}>
      <option value="">-- {t("select_bull")} --</option>
      {bulls.map((bull) => (
        <option key={bull._id} value={bull._id}>
          {bull.name}
        </option>
      ))}
    </select>
  );
};

export default BullDropdown;
